import { Component, createRef } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setAuthentication } from '../../redux/slices/authSlice';
import { setLanguages, setDefaultLanguage, setLangLabels, refreshLangLabels, setFirebaseToken } from '../../redux/slices/langSlice';
import { setSelectedChild } from '../../redux/slices/selectedChildSlice';
import { toast } from 'react-toastify';
import './login.css';
import logo from '../../assets/images/educore-new.png';
import loginImg from '../../assets/images/login-img.png';
import signingGoogle from '../../assets/images/signin-google.png';
import signingMicrosoft from '../../assets/images/signin-microsoft.png';
import axios from 'axios';
import { t } from '../../helpers/translation_helper';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { firebaseApp } from '../../services/firebase';
import { GET, POST } from '../../api';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginWrapper from '../../wrappers/GoogleLoginWrapper';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ReCAPTCHA from "react-google-recaptcha";

const apiURL = process.env.REACT_APP_API_URL;
const msalInstance = new PublicClientApplication({
    auth: {
        clientId: "b0b93e96-a815-4fd8-8724-38855f333745",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: window.location.origin,
    },
});


/**
 * Login Component
 */
class Login extends Component {

    googleLoginRef = createRef();

    /**
     * @constructor
     * @param {any} props
     */
    constructor(props) {
        super(props);

        this.state = {
            working: false,
            username: '',//0504051555
            password: '',//0504051555
            langLabels: [],
            langOffset: 0,
            loader: false,
            recaptchaToken: ""
        };
    }

    /**
     * Component Did Mount
     */
    componentDidMount() {
        this.props.refreshLangLabels(this.state.langOffset)
        axios.get(apiURL + 'language/get-languages').then((res) => {
            if (res.data.type) {
                this.props.setLanguages(res.data.data);
                const defaultLanguage = res.data.data.find((item) => {
                    return item.lang_name == 'English';
                });
                this.props.setDefaultLanguage(defaultLanguage);
            } else {
                toast.error('Something went wrong!');
            }
        });
    }


    /**
     * Handle Field
     * @param {event} e Event
     * @param {string} field Field name
     */
    handleField = (e, field) => {
        this.setState({ [field]: e.target.value });
    };

    authenticateUserAndGetTenantID = async (username, password) => {
        try {
            const res = await axios.get(apiURL + 'auth-user', {
                withCredentials: true,
                auth: {
                    username: username,
                    password: password,
                },
                params: {
                    appname: process.env.REACT_APP_NAME,
                }
            });

            if (res.data.type) {
                return {
                    success: true,
                    tenant_id: res.data.tenant_id
                };
            } else {
                return {
                    success: false,
                    message: res.data.message
                };
            }
        } catch (err) {
            console.log('Authentication error:', err);
            return {
                success: false,
                message: err.response?.data?.message || 'Authentication failed'
            };
        }
    };
    /**
     * Handle Login
     * @param {event} e Event
     */
    handleLogin = async (e) => {
        e.preventDefault();
        const { username, password, recaptchaToken } = this.state;

        if (!recaptchaToken) {
            toast.error("Please complete the reCAPTCHA.");
            return;
        }

        this.setState({ working: true });


        if (username == '' || password == '') {
            this.setState({ working: false });
            toast.error(t('Username and password is required.'));
            return;
        }

        try {
            const authResult = await this.authenticateUserAndGetTenantID(username, password);
            if (!authResult.success) {
                this.setState({ working: false });
                toast.error(authResult.message);
                return;
            }
            const loginParams = {
                appname: process.env.REACT_APP_NAME,
            };

            let tenantID = '';

            if (authResult.tenant_id) {
                loginParams.tenant_id = authResult.tenant_id;
                tenantID = authResult.tenant_id;
            }

            const res = await axios.get(apiURL + 'login', {
                withCredentials: true,
                auth: {
                    username: username,
                    password: password,
                },
                params: loginParams
            });

            if (res.data.type) {
                if (res.data.data.children.length > 0) {
                    this.setState({ working: false });
                    const { setAuthentication, setSelectedChild, setFirebaseToken } = this.props;


                    let isBrowserSupported = await isSupported()
                    if (isBrowserSupported) {
                        const messaging = getMessaging(firebaseApp);
                        getToken(messaging, {
                            vapidKey:
                                'BJ3u-j-0W2m1it06nryDvW8dV9X7uzl6i9la_lyEKPLYkmZHVxqGpCwF8l-vXCHx6sAcOa3O2WGnVdAsVbA2-Rc',
                        })
                            .then((currentToken) => {
                                if (currentToken) {
                                    setFirebaseToken(currentToken);
                                    this.registerFirebase(currentToken, res.data.data.centerData.center_id, res.data.data.centerData.center_timezone, res.data.data.loginData.user_id, res.data.data.loginData.role_id, res.data.data.loginData.auth_key, tenantID);
                                } else {
                                    console.log(
                                        'No registration token available. Request permission to generate one.'
                                    );
                                }
                            })
                            .catch((err) => {
                                console.log(
                                    'An error occurred while retrieving token. ',
                                    err
                                );
                            });
                    }

                    setAuthentication(res.data.data);
                    setSelectedChild(res.data.data.children[0]);
                } else {
                    this.setState({ working: false });
                    toast.error(t('No children have been found for this parent!'));
                }
            } else {
                this.setState({ working: false });
                toast.error(res.data.message);
            }
        } catch (err) {
            this.setState({ working: false });
            toast.error('Something went wrong!');
            console.log(err);
        }
    };

    handleRecaptchaChange = (token) => {
        this.setState({ recaptchaToken: token });
    };


    /**
   * Register Firebase
   * @param {String} currentToken
   * @param {Number} center_id
   * @param {Number} center_timezone
   * @param {Number} user_id
   * @param {Number} role_id
   * @param {String} auth_key
   * @param {String} tenant_id
   */
    registerFirebase = async (
        currentToken,
        center_id,
        center_timezone,
        user_id,
        role_id,
        auth_key,
        tenant_id
    ) => {
        let fData = new FormData();
        fData.append('currentToken', currentToken);
        fData.append('center_id', center_id);
        fData.append('center_timezone', center_timezone);
        fData.append('user_id', user_id);
        fData.append('role_id', role_id);
        fData.append('tenant_id', tenant_id);

        try {
            const res = await POST('authentication/register-firebase',
                fData,
                {
                    params: {
                        auth_key: auth_key,
                    },
                }
            );
            // 
        } catch (err) {
            console.log('err', err)
            toast.error(t('Something went wrong while saving token!'));
        }
    };

    /*******************************/
    /*           GOOGLE            */
    /*******************************/
    handleGoogleSuccess = async (credentialResponse) => {
        try {
            const fData = new FormData();
            fData.append('access_token', credentialResponse.access_token);
            const res = await axios.post(
                apiURL + 'auth-user',
                fData,
                {
                    params: {
                        appname: process.env.REACT_APP_NAME,
                        provider: 'google'
                    },
                }
            );

            if (res.data.type) {
                const authUserData = res.data;

                const loginParams = {
                    appname: process.env.REACT_APP_NAME,
                };

                let tenantID = '';

                if (authUserData.tenant_id) {
                    loginParams.tenant_id = authUserData.tenantID;
                    tenantID = authUserData.tenantID;
                }

                const loginRes = await axios.get(apiURL + 'login', {
                    withCredentials: true,
                    auth: {
                        username: authUserData.user_name,
                        password: authUserData.password,
                    },
                    params: loginParams
                });


                if (loginRes.data.type) {
                    const { setAuthentication, setFirebaseToken, setSelectedChild } = this.props;
                    // Firebase token registration
                    let isBrowserSupported = await isSupported()
                    if (isBrowserSupported) {
                        const messaging = getMessaging(firebaseApp);
                        getToken(messaging, {
                            vapidKey: 'BJ3u-j-0W2m1it06nryDvW8dV9X7uzl6i9la_lyEKPLYkmZHVxqGpCwF8l-vXCHx6sAcOa3O2WGnVdAsVbA2-Rc',
                        })
                            .then((currentToken) => {
                                if (currentToken) {
                                    setFirebaseToken(currentToken);
                                    this.registerFirebase(
                                        currentToken,
                                        loginRes.data.data.centerData.center_id,
                                        loginRes.data.data.centerData.center_timezone,
                                        loginRes.data.data.loginData.user_id,
                                        loginRes.data.data.loginData.role_id,
                                        loginRes.data.data.loginData.auth_key,
                                        loginRes.data.data.centerData,
                                        tenantID
                                    );
                                } else {
                                    console.log('No registration token available. Request permission to generate one.');
                                }
                            })
                            .catch((err) => {
                                console.log('An error occurred while retrieving token. ', err);
                            });
                    }

                    const role = loginRes.data.data.loginData.role_id.toString();

                    setAuthentication(loginRes.data.data);
                    setSelectedChild(loginRes.data.data.children[0]);

                } else {
                    toast.error(loginRes.data.message);
                }

            } else {
                toast.error(res.data.message);
                return;
            }

        } catch (err) {
            console.log('Google login error:', err);
            if (err.response) {
                let resData = err.response.data
                if (resData) {
                    toast.error(resData.message);
                } else {
                    toast.error('Something went wrong!');
                }
            } else {
                toast.error(t('No linked Google account found!'));
            }
            return;
        }
    };

    handleGoogleError = () => {
        toast.error('Google Sign-In failed!');
    };

    handleGoogleLogin = () => {
        if (this.googleLoginRef.current) {
            this.googleLoginRef.current.triggerLogin();
        }
    };

    /*******************************/
    /*          MICROSOFT          */
    /*******************************/
    handleMicrosoftLogin = async () => {
        try {
            const response = await msalInstance.loginPopup({
                scopes: ["user.read"],
                prompt: "select_account",
            });
            const access_token = response.accessToken;

            const fData = new FormData();
            fData.append('access_token', access_token);

            // First authenticate user and get tenant ID
            const res = await axios.post(
                apiURL + 'auth-user',
                fData,
                {
                    params: {
                        appname: process.env.REACT_APP_NAME,
                        provider: 'microsoft'
                    },
                }
            );

            if (res.data.type) {
                const authUserData = res.data;

                const loginParams = {
                    appname: process.env.REACT_APP_NAME,
                };

                let tenantID = '';

                if (authUserData.tenant_id) {
                    loginParams.tenant_id = authUserData.tenantID;
                    tenantID = authUserData.tenantID;
                }

                const loginRes = await axios.get(apiURL + 'login', {
                    withCredentials: true,
                    auth: {
                        username: authUserData.user_name,
                        password: authUserData.password,
                    },
                    params: loginParams
                });

                if (loginRes.data.type) {
                    const { setAuthentication, setSelectedChild, setFirebaseToken } = this.props;

                    let isBrowserSupported = await isSupported()
                    if (isBrowserSupported) {
                        const messaging = getMessaging(firebaseApp);
                        getToken(messaging, {
                            vapidKey:
                                'BJ3u-j-0W2m1it06nryDvW8dV9X7uzl6i9la_lyEKPLYkmZHVxqGpCwF8l-vXCHx6sAcOa3O2WGnVdAsVbA2-Rc',
                        })
                            .then((currentToken) => {
                                if (currentToken) {
                                    setFirebaseToken(currentToken);
                                    this.registerFirebase(
                                        currentToken,
                                        loginRes.data.data.centerData.center_id,
                                        loginRes.data.data.centerData.center_timezone,
                                        loginRes.data.data.loginData.user_id,
                                        loginRes.data.data.loginData.role_id,
                                        loginRes.data.data.loginData.auth_key,
                                        loginRes.data.data.centerData.tenant_id,
                                        tenantID
                                    );
                                } else {
                                    console.log(
                                        'No registration token available. Request permission to generate one.'
                                    );
                                }
                            })
                            .catch((err) => {
                                console.log(
                                    'An error occurred while retrieving token. ',
                                    err
                                );
                            });
                    }
                    const role = loginRes.data.data.loginData.role_id.toString();

                    setAuthentication(loginRes.data.data);
                    setSelectedChild(loginRes.data.data.children[0]);

                } else {
                    toast.error(loginRes.data.message);
                    return;
                }

            } else {
                toast.error(res.data.message);
                return;
            }

        } catch (error) {
            console.error("Microsoft login error:", error);
            if (error.response) {
                let resData = error.response.data
                if (resData) {
                    toast.error(resData.message);
                } else {
                    toast.error('Something went wrong!');
                }
            } else {
                toast.error(t('No linked Microsoft account found!'));
            }
        }
    };



    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        const { working, username, password, loader } = this.state;

        if (loader) {
            return (
                <div id='loader'>
                    <img src={require('../../assets/images/iedu-loader.gif')} alt='iEducore' width='120' />
                    {t('Please wait...')}
                    <br />
                    {t('Setting up student dashboard')}
                </div>
            );
        } else {
            return (
                <div style={{
                    backgroundColor: '#5CBDEB',
                    height: '100vh',
                    width: '100%',
                    overflow: 'hidden'
                }}>
                    <div id='login-form' className='d-flex justify-content-center align-items-center'>
                        <div className='d-flex justify-content-center align-items-center'
                            style={{ width: '50%', height: 690, backgroundColor: '#FAFAFA' }}>
                            <img
                                src={loginImg}
                                alt='iEducore'
                                width='100%'
                            />
                        </div>
                        <div style={{ width: '50%', height: 690, padding: 32 }}>
                            <div className='text-center'>
                                <img src={logo} alt='iEducore' width='150' />
                            </div>
                            <h3 className='text-center mt-4 mb-0'>{t('Welcome Back!')}</h3>
                            <div className='text-center mt-1 mb-4 text-muted'>
                                <small>{t('Sign in to access your account')}</small>
                            </div>
                            <GoogleOAuthProvider clientId="442389961490-j3l0rdb6avjckk0art33s7ebbn4lprtm.apps.googleusercontent.com">
                                <button
                                    onClick={this.handleGoogleLogin}
                                    style={{
                                        marginBottom: 16,
                                        borderRadius: 7,
                                        border: '1px solid rgba(0, 0, 0, 0.12)',
                                        backgroundColor: 'white',
                                        padding: 10,
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    <img src={signingGoogle} alt='Google' width='20' height='20' className='me-2' />{t('Continue with Google')}
                                </button>
                                <GoogleLoginWrapper
                                    ref={this.googleLoginRef}
                                    onSuccess={this.handleGoogleSuccess}
                                    onError={this.handleGoogleError}
                                />
                            </GoogleOAuthProvider>
                            <MsalProvider instance={msalInstance}>
                                <button
                                    onClick={this.handleMicrosoftLogin}
                                    style={{
                                        borderRadius: 7,
                                        border: '1px solid rgba(0, 0, 0, 0.12)',
                                        backgroundColor: 'white',
                                        padding: 10,
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    <img src={signingMicrosoft} alt='Microsoft' width='20' height='20' className='me-2' />{t('Continue with Microsoft')}
                                </button>
                            </MsalProvider>
                            <div className='text-center mt-4 mb-4 text-muted or-divider'>
                                <small>{t('or continue with username')}</small>
                            </div>
                            <Form onSubmit={this.handleLogin}>
                                <Form.Group className='mb-2' controlId='formBasicEmail'>
                                    <Form.Label>{t('Username')}</Form.Label>
                                    <Form.Control
                                        value={username}
                                        type='text'
                                        placeholder='User Name'
                                        onChange={(e) =>
                                            this.handleField(e, 'username')
                                        }
                                        autoComplete={'username'}
                                    />
                                </Form.Group>
                                <Form.Group
                                    style={{ position: 'relative' }}
                                    className='mb-4'
                                    controlId='formBasicPassword'>
                                    <Form.Label>{t('Password')}</Form.Label>
                                    <Form.Control
                                        value={password}
                                        type={this.state.showPass ? 'text' : 'password'}
                                        placeholder='Password'
                                        onChange={(e) =>
                                            this.handleField(e, 'password')
                                        }
                                        autoComplete={'password'}
                                    />

                                </Form.Group>
                                <button
                                    style={{
                                        width: '100%',
                                        border: 'none',
                                        color: 'white',
                                        borderRadius: 7,
                                        padding: 10,
                                        fontWeight: 'bold',
                                        backgroundColor: '#5CBDEB',
                                        fontSize: 14
                                    }}
                                    type='submit'
                                    disabled={working}>
                                    {t('Login')}{' '}
                                    {working ? (
                                        <Spinner
                                            as='span'
                                            animation='grow'
                                            size='sm'
                                            role='status'
                                            aria-hidden='true'
                                        />
                                    ) : (
                                        ''
                                    )}
                                </button>
                                <div className='d-flex justify-content-center' style={{ marginTop: 20 }}>
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        onChange={this.handleRecaptchaChange}
                                    />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({
    setAuthentication,
    setLanguages,
    setDefaultLanguage,
    setLangLabels,
    setSelectedChild,
    refreshLangLabels,
    setFirebaseToken,
});

export default connect(mapStateToProps, mapDispatchToProps())(Login);
